import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  App: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#f5f5f5",
  },
  wrapper: {
    display: "flex",
    position: "relative",
    maxWidth: "1080px",
    width: "100%",
    height: "580px",
    border: "1px solid #4a4a4a",
    boxShadow: "0 0 5px #4a4a4a",
  },
  window: {
    position: "relative",
    width: "50%",
    height: "100%",
    background: "white",
  },
  stream: {
    "& iframe": {
      border: "none",
      boxSizing: "border-box",
    },
  },
  splash_screen: {
    position: "absolute",
    zIndex: 1001,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    background: "#f5f5f5",
  },
  splash_screen_img: {
    display: "block",
    justifyContent: "center",
    margin: "0 auto",
    height: "70px",
  },
  splash_screen_title: {
    fontSize: "26px",
    fontWeight: 600,
    textTransform: "lowercase",
    letterSpacing: "2px",
    margin: "-10px 0 0 20px",
  },
  agent_navbar: {
    height: "38px",
    padding: "2px 4px 0 0",
    background: "#4a4a4a",
  },
  agent_body: {
    height: "calc(100% - 48px)",
  },
}));
